import { Component } from '@angular/core';

@Component({
  selector: 'app-button-loader',
  standalone: true,
  imports: [],
  templateUrl: './button-loader.component.html',
  styleUrl: './button-loader.component.scss'
})
export class ButtonLoaderComponent {

}
